// 登录
import request from "@/utils/request";

// 登录
export function fLogin(data) {
  return request({
    url: "/tax/login",
    method: "post",
    data: data
  });
}

// 登录
export function login(data) {
  return request({
    url: "/tax/confirmLogin",
    method: "post",
    data: data
  });
}

export function getSwitchAccount(data) {
  return request({
    url: "/tax/switchList",
    method: "post",
    data: data
  });
}

export function getInfo() {
  return request({
    url: "/tax/taxMenu/getUserMenuPower",
    method: "POST"
  });
}

export function logout() {
  return request({
    url: "/tax/logoutNew",
    method: "post"
  });
}

// 数据词典表查询
export function getItemByParentCode(data) {
  return request({
    url: "/tax/common/getItemByParentCode",
    method: "post",
    data: data
  });
}

// 根据服务商查行业
export function getBusinessByTaxId(data) {
  return request({
    url: "/tax/common/getBusinessByTaxId",
    method: "post",
    data: data
  });
}

// 开票类目
export function selectBillingCategory(data) {
  return request({
    url: "/tax/common/selectBillingCategory",
    method: "post",
    data: data
  });
}

// 查询签约模式
export function getSignWay(data) {
  return request({
    url: "/tax/agentCooperationManager/agent/sign/way",
    method: "post",
    data: data
  });
}

export function getAuthType(data) {
  return request({
    url: "/tax/agentCooperationManager/agent/au/type",
    method: "POST",
    data: data
  });
}

// 查询是否可自动开票
export function queryTaxByTaxId(data) {
  return request({
    url: "/tax/taxManage/queryTaxByTaxId",
    method: "post",
    data: data
  });
}

//开票管理-导出财务开票表
export function downloadExcel(params) {
  return request({
    url: "/tax/BillOrderInfo/downloadExcel",
    method: "get",
    params,
    exportFiles: true
  });
}
//开票管理-导出
export function getPageExport(params) {
  return request({
    url: "/tax/BillOrderInfo/getPageExport",
    method: "get",
    params,
    exportFiles: true
  });
}
// ai 弹框 参数获取
export function aiUserInfo(data) {
  return request({
    url: "/tax/common/system/userInfo",
    method: "post",
    data: data
  });
}
